import { render, staticRenderFns } from "./VideoAnnotation.vue?vue&type=template&id=734fde3d&"
import script from "./VideoAnnotation.vue?vue&type=script&lang=js&"
export * from "./VideoAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports